module.exports = __webpack_public_path__ + "static/GTAmerica-BoldItalic-6f2208038c85cad86f853fb63e0009e9.woff";